<template>
  <footer class="site-footer" v-if="setting && navigationCopyrights">
    <div class="site-footer-inner">
      <div class="container grid">
        <v-rich-text :content="setting.footer_aboutus" />
        <v-rich-text :content="setting.footer_openinghours" />
        <v-rich-text :content="setting.footer_route" />
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        <p>
          &copy; {{ currentYear}} {{ setting.copyright }} |
          <template v-for="(item, key) in navigationCopyrights">
            <router-link :key="item.id" :to="{ name: item.target }">
              {{ item.title }}
            </router-link>
            <template v-if="key < navigationCopyrights.length-1">
              |
            </template>
          </template>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import query from '@/services/api/query';

export default {
  name: 'vFooter',
  data() {
    return {
      setting: null,
      navigationCopyrights: null,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
  apollo: {
    setting: query.footer,
    navigationCopyrights: query.navigation_footer,
  },
  methods: {
    animate(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('animate__animated', 'animate__fadeInUp');
      }
    },
  },
  components: {
    vRichText: () => import('@/components/rich-text'),
  }
};
</script>
